import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);
const JournalDetailServices={
    async saveJournalDetail(_payload){
        var url="api/Save_Journal"
        return await ApiService.post(url, _payload);
    },
    async getActiveAccountPeriod(){
        const getActiveAccountPeriod = {
            url: "api/JournalActiveAccountingPeriod",
            top: "1",
          };
        return await ApiService.oDataGet(getActiveAccountPeriod);
    }
    
}
export {JournalDetailServices}